import Typography from "components/typography";
import LinkText from "components/typography/linkText";
import React from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";

const LyricRequirements = () => {
  return (
    <Body>
      <Typography weight="semibold" color="white" mb="1.2" m_size="s">
        Lyric Requirements
      </Typography>
      <Typography size="s" color={Colors.grey500} mb="0.8">
        Lyrics must adhere to the following guidelines or they may be rejected:
      </Typography>
      <List>
        <li>
          <Typography size="s">
            Lyrics must match the audio you’ve uploaded.
          </Typography>
        </li>{" "}
        <li>
          <Typography size="s">
            Don’t add commas at the end of each of line. End each new line with
            no punctuation.
          </Typography>
        </li>{" "}
        <li>
          <Typography size="s">
            Start each line with a capital letter. Don’t upload lyrics in all
            upper or lowercase
          </Typography>
        </li>{" "}
        <li>
          <Typography size="s">
            Any explicit words or repeated lines must be included in full.
          </Typography>
        </li>{" "}
        <li>
          <Typography size="s">
            Lyrics should be formatted like a poem. Every individual lyric line
            should have a single break. Each verse, chorus, bridge etc should be
            seperated into stanzas using a double line break.
          </Typography>
        </li>
      </List>
      <GuidelineText>
        <Typography size="s" color={Colors.grey500} mr="0.4">
          Before uploading lyrics, please read
        </Typography>
        <LinkText
          to="https://artists.apple.com/support/1111-lyrics-guidelines"
          text="Apple Music’s full lyric guidelines"
          size="s"
        />
      </GuidelineText>
    </Body>
  );
};

export default LyricRequirements;

const Body = styled.div`
  width: 100%;
  padding: 1.6rem;
  background-color: ${Colors.grey700};
  margin-bottom: 2.4rem;
`;

const List = styled.ul`
  padding: 0;
  margin: 0;
  margin-left: 1.2rem;
  color: ${Colors.grey500};

  li {
    margin-bottom: 0.8rem;
  }
`;

const GuidelineText = styled.div`
  display: inline-flex;
  align-items: center;
`;
